import { IconProps } from "./Icon.model";

export function TokenSquareIcon({
  size = 16,
  fill = "currentColor",
}: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* <rect
        width="24"
        height="24"
        transform="translate(0.700195 0.5)"
        fill={`var(--gray-a1)`}
      /> */}
      <path
        d="M12.751 2.25C14.8224 2.24999 16.4466 2.25004 17.7246 2.40527C19.0305 2.56392 20.0757 2.89441 20.9346 3.62793C21.1635 3.82348 21.3767 4.03668 21.5723 4.26563C22.3058 5.12447 22.6363 6.16971 22.7949 7.47559C22.9501 8.75346 22.9502 10.4796 22.9502 12.5508C22.9502 14.6222 22.9502 16.2464 22.7949 17.5244C22.6363 18.8303 22.3058 19.8755 21.5723 20.7344C21.3767 20.9633 21.1635 21.1765 20.9346 21.3721C20.0757 22.1056 19.0305 22.4361 17.7246 22.5947C16.4466 22.75 14.8224 22.75 12.751 22.75C10.6798 22.75 8.95366 22.75 7.67578 22.5947C6.36991 22.4361 5.32466 22.1056 4.46582 21.3721C4.23688 21.1765 4.02367 20.9633 3.82813 20.7344C3.0946 19.8755 2.76412 18.8303 2.60547 17.5244C2.45023 16.2464 2.45019 14.6222 2.4502 12.5508C2.45019 10.4796 2.45024 8.75346 2.60547 7.47559C2.76412 6.16971 3.0946 5.12447 3.82813 4.26563C4.02367 4.03669 4.23688 3.82348 4.46582 3.62793C5.32466 2.89441 6.36991 2.56392 7.67578 2.40527C8.95366 2.25005 10.6798 2.24999 12.751 2.25ZM13.208 7.27832C12.9714 6.90706 12.4289 6.90706 12.1924 7.27832L11.5078 8.35352C10.7511 9.54248 9.74268 10.5509 8.55371 11.3076L7.47852 11.9922C7.10725 12.2288 7.10725 12.7712 7.47852 13.0078L8.55371 13.6924C9.74268 14.4491 10.7511 15.4575 11.5078 16.6465L12.1924 17.7217C12.4289 18.0929 12.9714 18.0929 13.208 17.7217L13.8926 16.6465C14.6493 15.4575 15.6577 14.4491 16.8467 13.6924L17.9219 13.0078C18.2931 12.7712 18.2931 12.2288 17.9219 11.9922L16.8467 11.3076C15.6577 10.5509 14.6493 9.54248 13.8926 8.35352L13.208 7.27832Z"
        fill={fillColor}
      />
    </svg>
  );
}
